export default __webpack_public_path__ + "static/media/notification.aa8f8c40.mp3";